export const apiPaths = {
  role: {
    search: '/v1/mgmt/role/search',
    deleteBatch: '/v1/mgmt/role/delete/batch',
    create: '/v1/mgmt/role/create',
    update: '/v1/mgmt/role/update',
  },
  tenant: {
    permissions: '/v1/mgmt/permission/all',
  },
};
